var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDcType1 = function SvgDcType1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M10.5 15.491a7.396 7.396 0 1 0 0-14.79 7.396 7.396 0 0 0 0 14.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    d: "M7.552 6.916a1.777 1.777 0 1 0 0-3.555 1.777 1.777 0 0 0 0 3.555ZM13.45 6.916a1.777 1.777 0 1 0 0-3.555 1.777 1.777 0 0 0 0 3.555ZM10.5 13.866a1.777 1.777 0 1 0 0-3.554 1.777 1.777 0 0 0 0 3.554Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M14.83 10.4a.97.97 0 1 0-.742-1.792.97.97 0 0 0 .742 1.791ZM7.227 10.19a.97.97 0 1 0-1.37-1.371.97.97 0 0 0 1.37 1.37Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    d: "M13.017 19.258a1.256 1.256 0 1 0 0-2.511 1.256 1.256 0 0 0 0 2.511ZM7.984 19.258a1.256 1.256 0 1 0 0-2.511 1.256 1.256 0 0 0 0 2.511Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    d: "M13.644 20.3H7.357a2.293 2.293 0 0 1 0-4.586h6.287a2.293 2.293 0 1 1 0 4.586Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M13.081 18.038a.074.074 0 1 1-.132-.065.074.074 0 0 1 .132.065ZM8.052 18.038a.074.074 0 1 1-.132-.065.074.074 0 0 1 .132.065Z"
  })));
};
export default SvgDcType1;